{
  "translations": {
    "global": {
      "cancel": "Cancelar",
      "submit": "Enviar",
      "fieldRequired": "*Obligatorio"
    },
    "shiftForm": {
      "activeSites": "Lugares activos",
      "adminNotesHeader": "Notas administrativas",
      "dateLabel": "Fecha",
      "englishTab": "Inglés",
      "frequencyLabel": "Frecuencia",
      "frequencyCustomLabel": "Personalizar...",
      "frequencyRepeatUntilLabel": "Hasta",
      "frequencyRepeatUntilForever": "Se repite por siempre",
      "frequencyRepeatUntilDate": "Hasta",
      "frequencyRepeatNumOfShifts": "Cantidad de turnos",
      "frequencyRepeatNumOfShiftsLabel": "Número",
      "frequencyWeeklyOnDayPrefix": "Semanalmente los",
      "frequencyMonthlyOnDayPrefix": "Mensualmente los",
      "frequencyYearlyOnDatePrefix": "Anualmente los",
      "frequencyEveryWeekday": "Todas los días de la semana (de lunes a viernes)",
      "frequencyRepeatEndLabel": "Termina",
      "frequencyRepeatEndsNever": "Nunca",
      "frequencyRepeatEndsOn": "El",
      "frequencyRepeatEndsAfter": "Después de",
      "frequencyRepeatForOccurrences": "veces",
      "inactiveSites": "Lugares Inactivos",
      "nameLabel": "Nombre del turno",
      "publicNotesHeader": "Intrucciones del turno",
      "spanishTab": "Español",
      "submitForm": "Enviar",
      "taskLabel": "Tareas",
      "tasksHeader": "Tareas",
      "tasksMenuPlaceholder": "Agregar una tarea",
      "tasksRemove": "Eliminiar tarea",
      "timeRangeJoiner": "a",
      "userLabel": "Voluntario",
      "userMenuPlaceholder": "Agregar un voluntario",
      "usersHeader": "Voluntarios",
      "usersRemove": "Eliminar voluntario",
      "volunteerMinimumLabel": "Cantidad mínima requerida de voluntarios/as"
    },
    "rRule": {
      "customRecurrence": "Personalizar la frecuencia",
      "daily": "Todos los días",
      "day": "día",
      "dayDays": "día(s)",
      "doesNotRepeat": "No se repite",
      "each": "cada",
      "fifth": "quinto",
      "first": "primer",
      "fourth": "cuarto",
      "friday": "viernes",
      "fridayCode": "VI",
      "last": "último",
      "monday": "lunes",
      "mondayCode": "LU",
      "monthMonths": "mes(es)",
      "nd": ".º",
      "onThe": "del",
      "rd": ".º",
      "repeat": "Repetir",
      "repeatEvery": "Se repite cada",
      "repeatOn": "Se repite el se repite los",
      "saturday": "sábado",
      "saturdayCode": "SÁ",
      "second": "segundo",
      "st": ".º",
      "sunday": "domingo",
      "sundayCode": "DO",
      "th": ".º",
      "third": "tercero",
      "thursday": "jueves",
      "thursdayCode": "JU",
      "tuesday": "martes",
      "tuesdayCode": "MA",
      "wednesday": "miércoles",
      "wednesdayCode": "MI",
      "weekCodes": "DO,LU,MA,MI,JU,VI,SA",
      "weekday": "durante la semana",
      "weekdayCodes": "LU,MA,MI,JU,VI",
      "weekendCodes": "DO,SA",
      "weekWeeks": "semana(s)",
      "weekendDay": "día del fin de semana"
    }
  }
}
